var map = {
	"./parent/questions.json": 2546,
	"./school/questions.json": 2547,
	"./student/questions.json": 2548
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2545;


//////////////////
// WEBPACK FOOTER
// ./src/services/API/fixtures/onboarding ^\.\/.*\/questions\.json$
// module id = 2545
// module chunks = 0